import { WorkStepCreationOptions } from "./WorkStepCreationOptions";
import { useOptroBulkImportEnabled } from "../../../../hooks/useOptroBulkImportEnabled";

// Shown when the workspace has no work steps at all (not for filtered-empty
// results). Mirrors ControlsWelcomeState.
export const WorkStepsWelcomeState = () => {
  const optroBulkImportEnabled = useOptroBulkImportEnabled();
  return (
    <WorkStepCreationOptions
      title="Welcome to Midship"
      subtitle={
        optroBulkImportEnabled
          ? "Get your work step library set up in minutes. Most of your work step data already lives in Optro and carries over automatically."
          : "Get your work step library set up in minutes."
      }
    />
  );
};
